export default __webpack_public_path__ + "static/media/FAC10.69068757.jpg";